import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Entry } from 'contentful';
import { WebinarpageService } from 'src/app/features/company/resources/webinars-and-podcasts/webinarpage.service';

@Injectable({
  providedIn: 'root',
})
export class WebinarArticleResolver implements Resolve<Entry<any>[]> {
  constructor(private webinarPageService: WebinarpageService) {}

  resolve(route: ActivatedRouteSnapshot): Promise<Entry<any>[]> {
    return this.webinarPageService.getwebinarArticleByID(
      route.paramMap.get('whitepaperid')
    );
  }
}
